const C = require("../constants");

function ClientSelectReducer(state = null, action) {
    switch (action.type) {
        case C.SELECT_CLIENT:
            return action.data;
        default:
            return state;
    }
}

export default ClientSelectReducer;


// WEBPACK FOOTER //
// ./src/reducers/ClientSelectReducer.js